<div class="header" [ngClass]="{ test: isOpnen }">
  <ng-content select="wchfs-expanded-list-header"></ng-content>
</div>
<div class="rows-container" [ngClass]="{ 'container-hidden': !isOpnen }">
  <ng-content select="wchfs-expanded-list-content"></ng-content>
</div>
